import styled from "styled-components"

const StyledFooter = styled.div`
  margin: 2rem 0 3rem 0;
  font-style: italic;
  font-size: 0.8rem;
`

const Footer = () => {
  return (<StyledFooter>(c) Szymon Sarnowicz 2026</StyledFooter>)
}

export default Footer